
export default {
  phone: /^(\+?0?86-?)?1[3-9]\d{9}$/,
  password: /^[A-Za-z0-9]{6,18}$/,
  username: /^[A-Za-z0-9]{6,36}$/,
}